module.exports = __webpack_public_path__ + "static/media/29_B.1fe1e4a8.png";